import styled from 'styled-components'

export default styled.div.attrs({ className: 'col-12 col-md' })`
  > * {
    vertical-align: middle;
    margin-right: 10px;
  }
`
